<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.25 17.25L6.75 6.75"
      :stroke="fillColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.25 6.75L6.75 17.25"
      :stroke="fillColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "CloseSVG",
    props: {
    fillColor: {
      type: String,
      default: "#242424",
    },
  },
};
</script>

<style>
</style>